export enum ColumnTypeEnum {
  COLUMN_12 = 'COLUMN_12',
  COLUMN_8 = 'COLUMN_8',
  COLUMN_6 = 'COLUMN_6',
  COLUMN_4 = 'COLUMN_4',
  COLUMN_3 = 'COLUMN_3',
}
